import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { AuthGuard, CGUGuard } from 'app/core/auth/guards/auth.guard';
import { MechanicRedirectGuard } from 'app/core/auth/guards/mechanicRedirect.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [
    // Redirect empty path to '/example'
    { path: '', pathMatch: 'full', redirectTo: 'dashboard' },

    // Redirect signed-in user to the '/example'
    //
    // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    { path: 'signed-in-redirect', pathMatch: 'full', redirectTo: 'dashboard' },

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: 'sign-in',
                loadChildren: () =>
                    import('app/modules/auth/sign-in/sign-in.routes'),
            },
            {
                path: 'authredirect',
                loadChildren: (): Promise<any> =>
                    import(
                        'app/modules/auth/authredirect/authredirect.routing'
                    ).then(m => m.authRedirectRoutes),
            },
            {
                path: 'forgot-password',
                loadChildren: () =>
                    import('app/modules/auth/forgot-password/forgot-password.routing').then(m => m.authForgotPasswordRoutes),
            },
            {
                path: 'join',
                loadChildren: () =>
                    import('app/modules/auth/join/join.routing').then(m => m.joinRoutes),
            },
        ],
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: 'password-reset',
                loadChildren: () =>
                    import('app/modules/auth/password-reset/password-reset.routes'),
            },
            {
                path: 'accept-cgu',
                canActivate: [CGUGuard],
                loadChildren: () =>
                    import('app/modules/auth/cgu-acceptation/cgu-acceptation.routes'),
            },
            {
                path: 'sign-out',
                loadChildren: () =>
                    import('app/modules/auth/sign-out/sign-out.routes'),
            }
        ],
    },

    // App routes
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver,
        },
        children: [
            {
                path: 'dashboard',
                canActivate: [MechanicRedirectGuard],
                loadChildren: () =>
                    import('app/modules/dashboard/dashboard.routes'),
            },
            {
                path: '',
                loadChildren: () =>
                    import('app/modules/saisies/saisies.routes'),
            },
            // {
            //     path: 'conges',
            //     loadChildren: () =>
            //         import('app/modules/conges/conges.routes'),
            // },
            // {
            //     path: 'conges-en-attente',
            //     loadChildren: () =>
            //         import('app/modules/conges-en-attente/conges-en-attente.routes'),
            // },
            {
                path: 'clients',
                loadChildren: () =>
                    import('app/modules/clients-list/clients-list.routes'),
            },
            {
                path: 'contrats',
                loadChildren: () =>
                    import('app/modules/contrats/contrats.routes'),
            },
            {
                path: 'plannings',
                loadChildren: () =>
                    import('app/modules/plannings/plannings.routes'),
            },
            {
                path: 'plannification',
                loadChildren: () =>
                    import('app/modules/plannification/plannification.routes'),
            },
            {
                path: 'synthese',
                loadChildren: () =>
                    import('app/modules/synthese/synthese.routes'),
            },
            {
                path: 'synthese-cdtx',
                loadChildren: () =>
                    import('app/modules/synthese-cdtx/synthese-cdtx.routes'),
            },
            {
                path: 'synthese-atelier',
                loadChildren: () =>
                    import('app/modules/synthese-atelier/synthese-atelier.routes'),
            },
            // {
            //     path: 'prepaie',
            //     loadChildren: () =>
            //         import('app/modules/prepaie/prepaie.routes')
            // },
            {
                path: 'statistiques',
                loadChildren: () =>
                    import('app/modules/statistiques/statistiques.routes')
            },
            {
                path: 'export-deblais',
                loadChildren: () =>
                    import('app/modules/export-deblais/export-deblais.routes')
            },
            {
                path: 'interventions',
                loadChildren: () =>
                    import('app/modules/interventions-list/interventions-list.routes'),
            },
            // {
            //     path: 'gps-chantier',
            //     loadChildren: () =>
            //         import('app/modules/gps-chantier/gps-chantier.routes'),
            // },
            {
                path: 'documents',
                loadChildren: () =>
                    import('app/modules/documents/documents.routes'),
            },
            {
                path: 'configurations',
                loadChildren: () =>
                    import(
                        'app/modules/configurations/configurations.routes'
                    ),
            },
            {
                path: 'profile',
                loadChildren: () =>
                    import('app/modules/profile/profile.routes'),
            },
        ],
    },
    { path: '**', redirectTo: '' },
];
